export default "__VITE_PUBLIC_ASSET__57928702__"